import { MailRecipient } from '../../types/ViewModel/Vessel/MailRecipient';
import { MailRecipientBM } from '../../types/BusinessModel/Vessel/MailRecipientBM';

export class MailRecipientFactory {
    constructor() {}
    public getMailRecipient(mailRec: MailRecipientBM | null): MailRecipient | null {
        if (mailRec) {
            return new MailRecipient(mailRec.email, mailRec.name);
        }
        return null;
    }
}
